<template>
  <Modal title="顧客情報" :loading="detail.busy" @close="close">
    <template #content>
      <div class="customer-modal">
        <div class="customer-detail">
          <CustomerInfo v-if="detail.customer" :customer="detail.customer" />
        </div>
        <p class="description sp-none">
          以下のご登録メールアドレスに、顧客情報のPDFデータをお送りします。{{ currentUser.mail }}
        </p>
        <div class="buttons">
          <Button class="sp-none" @click="sendPdf">顧客情報のPDFデータを送信する</Button>
          <Button @click="toCustomer">顧客台帳で詳しく見る</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/atoms/Button'
import { showDialog } from '@/components/molecules/Dialog'
import Modal from '@/components/molecules/Modal'
import CustomerInfo from '@/components/molecules/CustomerInfo'

export default {
  name: 'CustomerInfoModal',
  components: {
    Button,
    Modal,
    CustomerInfo,
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      currentUser: state => state.users.current.user,
      detail: state => state.customers.detail,
    }),
  },
  methods: {
    async sendPdf() {
      if (await this.$store.dispatch('customers/detail/sendPdf')) {
        showDialog({
          title: '送信完了',
          message: `以下のご登録メールアドレスに、\n顧客情報のPDFデータをお送りしました。\n${this.currentUser.mail}`,
          okText: '閉じる',
        })
      }
    },
    toCustomer() {
      const { id } = this.detail.customer
      if (this.isSP) {
        this.$emit('close')
        this.$router.push({
          name: 'CustomerDetail',
          params: { id, onlyEdit: true },
          query: { backTo: this.$route.fullPath },
        })
      } else {
        location.assign(`/customer/init?customer_id=${id}`)
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.customer-modal {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px 16px;
}

.customer-detail {
  box-sizing: border-box;
  flex: 1;
  margin: 0 -24px;
  max-height: 520px;
  min-height: 382px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 16px 24px 0;

  .responsive & {
    @media screen and (--sp-modal) {
      max-height: none;
    }
  }
}

.description {
  color: var(--very-dark-gray-2);
  font-size: 13px;
  margin: 4px 0;
}

.buttons {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: end;

  .responsive & {
    @media screen and (--sp-modal) {
      display: block;
      padding: 24px 0 8px;
      .button {
        height: 40px;
        width: 100%;
      }
    }
  }

  .button {
    border-radius: 4px;
    font-size: 15px;
    height: 32px;
    line-height: 30px;
    padding: 0 8px;
    width: fit-content;
  }
}

.responsive {
  @media screen and (--sp-modal) {
    .sp-none {
      display: none;
    }
  }
}
</style>
